export default __webpack_public_path__ + "static/media/icon_skill_shield.5cbd3f1f.png";